import { parseFiniteNumber } from '../../parse-finite-number.js';
import { refineCustomerPaidWithinPrice } from './refine-customer-paid-within-price.js';
/** Compares a line's two prices only once both parse, since each field reports its own malformed value. */
export function refineCreditLineForm(line, context) {
    const unitPrice = parseFiniteNumber(line.unitPrice);
    const customerPaid = parseFiniteNumber(line.customerPaid);
    if (unitPrice === undefined || customerPaid === undefined)
        return;
    refineCustomerPaidWithinPrice({ unitPrice, customerPaid }, context);
}
//# sourceMappingURL=refine-credit-line-form.js.map